<!--
 * @Author: Merlin
 * @Date: 2024-04-29 17:55:23
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-15 10:56:53
 * @Description: 组件用于显示金额，将尾部虚数0改为浅色
    将数字补0： 123456 => 123456.000
    补 0 之后将补位的 0 显示为浅色
-->
<template>
    <!-- ● 此处或可以考虑显示币种图标 -->
    <!-- ↓ 如果收到空字符，则不采用 #fff，并自动“继承” 颜色 --> 
    <span :style="{color: colors[0] ?? '#fff'}">
        {{ aNumber2Show[0] }}<span v-if="aNumber2Show[1]" :style="{color: colors[1] ?? '#55657e'}">{{ aNumber2Show[1] }}</span>
    </span>
</template>

<script lang='ts' setup>
const props = defineProps({
    colors: {
        type: Object as PropType<string[]>,
        default: ()=>[],
    },
    amount: { // 要显示的金额 
        type: [Number, Array],
        default: 0,
    },
    accuracy: { // 表示保留几位小数 
        type: Number,
        default: 2, // 默认2位小数（特意问过，这项目保留2位足矣，甚至下注输入框都只保留2位） 
    },
});

const aNumber2Show = computed(()=>{
    if (Array.isArray(props.amount)){
        return props.amount;
    }
    const arr = splitNumber(
        props.amount,
        props.accuracy,
    );
    return arr;
});
</script>


